<template>
    <div class="layout-external defaultTheme">
        <div class="left">
            <img
                :src="logo"
                class="logo"
                alt="Logo P2U"
            />
            <router-view></router-view>
        </div>
        <div class="right">
            <Welcome />
            <img
                :src="fundoBorda"
                class="bordaLogin"
                alt="Background desktop"
            />
            <img
                :src="backgroundMobile"
                class="background-mobile"
                alt="Background Mobile"
            />
        </div>
    </div>
</template>

<script>
    import { ref, onMounted, defineComponent } from 'vue'
    import Welcome from '@/components/Welcome.vue'

    export default defineComponent({
        name: 'LayoutExterno',

        components: {
            Welcome,
        },

        setup() {
            const logo = new URL('@/assets/images/logoLogin.svg', import.meta.url).href
            const fundoBorda = new URL('@/assets/images/fundobordadireita.svg', import.meta.url)
                .href
            const backgroundMobile = new URL(
                '@/assets/images/background-external-mobile.png',
                import.meta.url,
            ).href

            const carregado = ref(false)

            onMounted(() => {
                carregado.value = true
            })

            return {
                logo,
                fundoBorda,
                backgroundMobile,
                carregado,
            }
        },
    })
</script>

<style lang="scss" scoped>
    /* ================= DESKTOP ================= */
    @media only screen and (min-width: 1024px) {
        .layout-external {
            display: flex;
            flex-direction: row;
            width: 100vw;
            height: 100vh;
            overflow: hidden;

            .left {
                width: 45vw;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                z-index: 10;
                margin-top: 10rem;
                padding: 0 2rem;

                .logo {
                    width: 100%;
                    max-width: 34rem; 
                    height: 5rem;
                    object-fit: contain;
                    object-position: left bottom; 
                    
                    margin-bottom: 1rem;
                }
                
                :deep(div), :deep(.container-login) {
                    width: 100%;
                    max-width: 34rem;
                }
            }

            .right {
                width: 55vw;
                height: 100vh;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .bordaLogin {
                    position: absolute;
                    top: 0;
                    right: 0;
                    height: 100vh;
                    width: auto;   
                    object-fit: cover;
                    z-index: 0;
                }

                :deep(.welcome-container), :deep(div) {
                    z-index: 1;
                    position: relative;
                    width: 80%;
                    max-width: 600px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }

                :deep(img) {
                    margin-bottom: -1rem !important; 
                    transform: scale(1.05);
                }

                :deep(h1), :deep(h2) {
                    margin-top: -1.5rem !important; 
                    position: relative;
                    z-index: 2;
                }
                
                .background-mobile {
                    display: none;
                }
            }
        }
    }

    /* ================= MOBILE e TABLET ================= */
    @media only screen and (max-width: 1023px) {
        .layout-external {
            display: flex;
            flex-direction: column;
            min-height: 100vh;
            width: 100vw;
            position: relative;
            overflow-x: hidden;

            .left {
                width: 100%;
                margin: 0;
                padding: 0;
                height: auto;
                display: flex;
                flex-direction: column;
                align-items: center;
                z-index: 2;

                .logo {
                    margin-top: 4vh;
                    height: 8vh;
                    margin-bottom: 6vh;
                    object-fit: contain;
                }

                :deep(.container-login) {
                    margin-top: 0;
                }
            }

            .right {
                width: 100%;
                position: static;

                :deep(div),
                .bordaLogin {
                    display: none;
                }

                .background-mobile {
                    display: block;
                    position: fixed;
                    bottom: 0;
                    right: 0;
                    width: 100%;
                    max-height: 54vh;
                    object-fit: cover;
                    z-index: 1;
                    opacity: 1;
                }
            }
        }
    }
</style>
